import { render, staticRenderFns } from "./add-address.vue?vue&type=template&id=6f686fdb&scoped=true&"
import script from "./add-address.vue?vue&type=script&lang=js&"
export * from "./add-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f686fdb",
  null
  
)

export default component.exports